import { useEffect, useRef, useState } from 'react';

export function useThrottle<T>(value: T, interval = 500): T {
  const [throttledValue, setThrottledValue] = useState<T>(value);
  const lastExecuted = useRef<number>(-1);

  useEffect(() => {
    const now = Date.now();
    if (now >= lastExecuted.current + interval) {
      lastExecuted.current = now;
      const timeout = setTimeout(() => setThrottledValue(value), 0);
      return () => clearTimeout(timeout);
    }
    const timeout = setTimeout(() => {
      lastExecuted.current = Date.now();
      setThrottledValue(value);
    }, interval);
    return () => clearTimeout(timeout);
  }, [value, interval]);

  return throttledValue;
}
